// ***********************************
// Charts.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">
      <div>
        <router-link :to="{ name: 'Main'}">List</router-link> | 
        <router-link :to="{ name: 'Add'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> 
      </div>

Use this page to create custom charts for your database.
  <b-button v-b-toggle.morehelp variant="link">Click here to see more instructions.</b-button>
<br/>
  <b-collapse id="morehelp">
    <b-card           border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
>
    <div id="morehelptext" class="mt-3 text-left">
      This page lets you define different kinds of charts.<br/><br/>      
    </div>
        
    </b-card>

  </b-collapse>  

    <a name="daterange"></a>
    <div>
      <b-card title="Custom Date Range for Charts">
        <b-card-text>

          <p style="font-size:14px">You can use the following controls if you want to narrow down the date range shown in the various charts on this page.
           </p>
        </b-card-text>
        
        <b-container class="bv-example-row">
          <b-row>
            <b-col>
              Chart Start Date
            </b-col><b-col>
              Chart End Date
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-datepicker id="start-datepicker" v-model="start_date" :min="start_date_min" :max="end_date_max" class="mb-2" size="sm" @input="changeAdhocMetricGroupAll"></b-form-datepicker>
            </b-col><b-col>
              <b-form-datepicker id="end-datepicker" v-model="end_date" :min="start_date_min" :max="end_date_max" class="mb-2" size="sm" @input="changeAdhocMetricGroupAll"></b-form-datepicker>
            </b-col>
          </b-row>
            <b-row>
              <b-col>
                <b-button @click="start_date = start_date_min; end_date = end_date_max; changeAdhocMetricGroupAll('x')" size="sm" >Reset Dates</b-button>
              </b-col>  
            </b-row>

        </b-container>

      </b-card>  
    </div>



        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            Chart 1
          </b-card-header>
            <b-card-body>

              <b-form-group label="Chart Type:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available chart types'">
                <b-form-select v-model="chart1_type" size="sm" @change="showchart1=false">
                  <option value="single">Single Metric</option>
                  <option value="singleRAC" v-if="this.instances>1 && (chart1_group!='SYSSTAT')">Single Metric - broken out by RAC instances</option>
                  <option value="dual">Two Metrics with a single Y axis</option>
                  <option value="dual_stacked">Two Metrics Stacked with a single Y axis</option>
                  <!--<option value="dual_y">Two Metrics with dual Y axis</option>-->
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric Group:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metric groups'">
                <b-form-select v-model="chart1_group" size="sm" @change="changeAdhocMetricGroup1">
                  <option value="MAIN_METRICS">Main Metrics</option>
                  <option value="SYSSTAT">SYSSTAT Metrics</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric1:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart1_metric1" size="sm" @change="showchart1=false" :options="column_lov1">
                </b-form-select>

              </b-form-group>

              <b-form-group v-if="(chart1_type=='dual')||(chart1_type=='dual_stacked')" label="Metric2:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart1_metric2" size="sm" @change="showchart1=false" :options="column_lov1">
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="(chart1_type!='singleRAC') && (chart1_group!='SYSSTAT') && this.instances>1" label="RAC Instance:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick the RAC Instance to chart, or pick the entire cluster.'">
                <b-form-select v-if="this.instances>1" v-model="chart1_instances" :options="instanceChoices" size="sm" @change="showchart1=false" >
                </b-form-select>  
              </b-form-group>


              <b-form-checkbox v-if="(chart1_type=='single')" v-model="showReflineschart1" switch @change="showchart1=false" >Show Reference Lines</b-form-checkbox>

              <b-button v-if="!showchart1" v-model="showchart1" @click="showchart1 = !showchart1">Draw/Update Chart</b-button>
<br/>
                  <timechart2container
                  v-if="showchart1 && (chart1_type=='single')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart1_metric1 + instanceLabel"
                    :chart_id="chart1_group + '~' + chart1_metric1"
                    colorScheme="adhoc1"
                    :reflines="this.showReflineschart1"
                    :instance_num="this.chart1_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>


                  <timechartRACcontainer
                  v-if="showchart1 && (chart1_type=='singleRAC')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart1_metric1 + instanceLabel"
                    :chart_id="chart1_group + '~' + chart1_metric1"
                    colorScheme="adhoc1"
                    stacked=false
                    :num_instances="this.instances"
                    :instancenum_list="this.instancenums"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechartRACcontainer>

                  <timechart2container 
                    v-if="showchart1 && (chart1_type=='dual')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart1_metric1 + instanceLabel+':'+chart1_metric2 + instanceLabel"
                    :chart_id="chart1_group + '~' + chart1_metric1+':'+chart1_metric2"
                    stacked="false"
                    colorScheme="adhoc2"
                    reflines=false
                    :instance_num="this.chart1_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

                  <timechart2container 
                    v-if="showchart1 && (chart1_type=='dual_stacked')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart1_metric1 + instanceLabel+':'+chart1_metric2 + instanceLabel"
                    :chart_id="chart1_group + '~' + chart1_metric1+':'+chart1_metric2"
                    stacked="true"
                    colorScheme="adhoc2stacked"
                    reflines=false
                    :instance_num="this.chart1_instances"
                  ></timechart2container>

      
            </b-card-body>
          </b-card>


        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            Chart 2
          </b-card-header>
            <b-card-body>

              <b-form-group label="Chart Type:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available chart types'">
                <b-form-select v-model="chart2_type" size="sm" @change="showchart2=false">
                  <option value="single">Single Metric</option>
                  <option value="singleRAC" v-if="this.instances>1 && (chart2_group!='SYSSTAT')">Single Metric - broken out by RAC instances</option>
                  <option value="dual">Two Metrics with a single Y axis</option>
                  <option value="dual_stacked">Two Metrics Stacked with a single Y axis</option>
                  <!--<option value="dual_y">Two Metrics with dual Y axis</option>-->
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric Group:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metric groups'">
                <b-form-select v-model="chart2_group" size="sm" @change="changeAdhocMetricGroup2">
                  <option value="MAIN_METRICS">Main Metrics</option>
                  <option value="SYSSTAT">SYSSTAT Metrics</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric1:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart2_metric1" size="sm" @change="showchart2=false" :options="column_lov2">
                </b-form-select>

              </b-form-group>

              <b-form-group v-if="(chart2_type=='dual')||(chart2_type=='dual_stacked')" label="Metric2:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart2_metric2" size="sm" @change="showchart2=false" :options="column_lov2">
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="(chart2_type!='singleRAC') && (chart2_group!='SYSSTAT') && this.instances>1"  label="RAC Instance:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick the RAC Instance to chart, or pick the entire cluster.'">
                <b-form-select v-if="this.instances>1" v-model="chart2_instances" :options="instanceChoices" size="sm" @change="showchart2=false" >
                </b-form-select>  
              </b-form-group>


              <b-form-checkbox v-if="(chart2_type=='single')" v-model="showReflineschart2" switch @change="showchart2=false" >Show Reference Lines</b-form-checkbox>

              <b-button v-if="!showchart2" v-model="showchart2" @click="showchart2 = !showchart2">Draw/Update Chart</b-button>
<br/>
                  <timechart2container
                  v-if="showchart2 && (chart2_type=='single')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart2_metric1 + instanceLabel"
                    :chart_id="chart2_group + '~' + chart2_metric1"
                    colorScheme="adhoc1"
                    :reflines="this.showReflineschart2"
                    :instance_num="this.chart2_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>


                  <timechartRACcontainer
                  v-if="showchart2 && (chart2_type=='singleRAC')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart2_metric1 + instanceLabel"
                    :chart_id="chart2_group + '~' + chart2_metric1"
                    colorScheme="adhoc1"
                    stacked=false
                    :num_instances="this.instances"
                    :instancenum_list="this.instancenums"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechartRACcontainer>


                  <timechart2container 
                    v-if="showchart2 && (chart2_type=='dual')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart2_metric1 + instanceLabel+':'+chart2_metric2 + instanceLabel"
                    :chart_id="chart2_group + '~' + chart2_metric1+':'+chart2_metric2"
                    stacked="false"
                    colorScheme="adhoc2"
                    reflines=false
                    :instance_num="this.chart2_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

                  <timechart2container 
                    v-if="showchart2 && (chart2_type=='dual_stacked')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart2_metric1 + instanceLabel+':'+chart2_metric2 + instanceLabel"
                    :chart_id="chart2_group + '~' + chart2_metric1+':'+chart2_metric2"
                    stacked="true"
                    colorScheme="adhoc2stacked"
                    reflines=false
                    :instance_num="this.chart2_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

      
            </b-card-body>
          </b-card>


        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            Chart 3
          </b-card-header>
            <b-card-body>

              <b-form-group label="Chart Type:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available chart types'">
                <b-form-select v-model="chart3_type" size="sm" @change="showchart3=false">
                  <option value="single">Single Metric</option>
                  <option value="singleRAC" v-if="this.instances>1 && (chart3_group!='SYSSTAT')">Single Metric - broken out by RAC instances</option>
                  <option value="dual">Two Metrics with a single Y axis</option>
                  <option value="dual_stacked">Two Metrics Stacked with a single Y axis</option>
                  <!--<option value="dual_y">Two Metrics with dual Y axis</option>-->
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric Group:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metric groups'">
                <b-form-select v-model="chart3_group" size="sm" @change="changeAdhocMetricGroup3">
                  <option value="MAIN_METRICS">Main Metrics</option>
                  <option value="SYSSTAT">SYSSTAT Metrics</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric1:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart3_metric1" size="sm" @change="showchart3=false" :options="column_lov3">
                </b-form-select>

              </b-form-group>

              <b-form-group v-if="(chart3_type=='dual')||(chart3_type=='dual_stacked')" label="Metric2:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart3_metric2" size="sm" @change="showchart3=false" :options="column_lov3">
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="(chart3_type!='singleRAC') && (chart3_group!='SYSSTAT') &&  this.instances>1" label="RAC Instance:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick the RAC Instance to chart, or pick the entire cluster.'">
                <b-form-select v-if="this.instances>1" v-model="chart3_instances" :options="instanceChoices" size="sm" @change="showchart3=false" >
                </b-form-select>  
              </b-form-group>


              <b-form-checkbox v-if="(chart3_type=='single')" v-model="showReflineschart3" switch @change="showchart3=false" >Show Reference Lines</b-form-checkbox>

              <b-button v-if="!showchart3" v-model="showchart3" @click="showchart3 = !showchart3">Draw/Update Chart</b-button>
<br/>
                  <timechart2container
                  v-if="showchart3 && (chart3_type=='single')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart3_metric1 + instanceLabel"
                    :chart_id="chart3_group + '~' + chart3_metric1"
                    colorScheme="adhoc1"
                    :reflines="this.showReflineschart3"
                    :instance_num="this.chart3_instances":start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>


                  <timechartRACcontainer
                  v-if="showchart3 && (chart3_type=='singleRAC')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart3_metric1 + instanceLabel"
                    :chart_id="chart3_group + '~' + chart3_metric1"
                    colorScheme="adhoc1"
                    stacked=false
                    :num_instances="this.instances"
                    :instancenum_list="this.instancenums"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechartRACcontainer>


                  <timechart2container 
                    v-if="showchart3 && (chart3_type=='dual')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart3_metric1 + instanceLabel+':'+chart3_metric2 + instanceLabel"
                    :chart_id="chart3_group + '~' + chart3_metric1+':'+chart3_metric2"
                    stacked="false"
                    colorScheme="adhoc2"
                    reflines=false
                    :instance_num="this.chart3_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

                  <timechart2container 
                    v-if="showchart3 && (chart3_type=='dual_stacked')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart3_metric1 + instanceLabel+':'+chart3_metric2 + instanceLabel"
                    :chart_id="chart3_group + '~' + chart3_metric1+':'+chart3_metric2"
                    stacked="true"
                    colorScheme="adhoc2stacked"
                    reflines=false
                    :instance_num="this.chart3_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

      
            </b-card-body>
          </b-card>


        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            Chart 4
          </b-card-header>
            <b-card-body>

              <b-form-group label="Chart Type:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available chart types'">
                <b-form-select v-model="chart4_type" size="sm" @change="showchart4=false">
                  <option value="single">Single Metric</option>
                  <option value="singleRAC" v-if="this.instances>1 && (chart4_group!='SYSSTAT')">Single Metric - broken out by RAC instances</option>
                  <option value="dual">Two Metrics with a single Y axis</option>
                  <option value="dual_stacked">Two Metrics Stacked with a single Y axis</option>
                  <!--<option value="dual_y">Two Metrics with dual Y axis</option>-->
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric Group:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metric groups'">
                <b-form-select v-model="chart4_group" size="sm" @change="changeAdhocMetricGroup4">
                  <option value="MAIN_METRICS">Main Metrics</option>
                  <option value="SYSSTAT">SYSSTAT Metrics</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Metric1:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart4_metric1" size="sm" @change="showchart4=false" :options="column_lov4">
                </b-form-select>

              </b-form-group>

              <b-form-group v-if="(chart4_type=='dual')||(chart4_type=='dual_stacked')" label="Metric2:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick one of the available metrics to use in the chart'">
                <b-form-select v-model="chart4_metric2" size="sm" @change="showchart4=false" :options="column_lov4">
                </b-form-select>
              </b-form-group>

              <b-form-group v-if="(chart4_type!='singleRAC') && (chart4_group!='SYSSTAT') && this.instances>1" label="RAC Instance:" label-cols="3" label-size="sm" 
                v-b-tooltip.hover="'Pick the RAC Instance to chart, or pick the entire cluster.'">
                <b-form-select v-if="this.instances>1" v-model="chart4_instances" :options="instanceChoices" size="sm" @change="showchart4=false" >
                </b-form-select>  
              </b-form-group>


              <b-form-checkbox v-if="(chart4_type=='single')" v-model="showReflineschart4" switch @change="showchart4=false" >Show Reference Lines</b-form-checkbox>

              <b-button v-if="!showchart4" v-model="showchart4" @click="showchart4 = !showchart4">Draw/Update Chart</b-button>
<br/>
                  <timechart2container
                  v-if="showchart4 && (chart4_type=='single')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart4_metric1 + instanceLabel"
                    :chart_id="chart4_group + '~' + chart4_metric1"
                    colorScheme="adhoc1"
                    :reflines="this.showReflineschart4"
                    :instance_num="this.chart4_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>


                  <timechartRACcontainer
                  v-if="showchart4 && (chart4_type=='singleRAC')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart4_metric1 + instanceLabel"
                    :chart_id="chart4_group + '~' + chart4_metric1"
                    colorScheme="adhoc1"
                    stacked=false
                    :num_instances="this.instances"
                    :instancenum_list="this.instancenums"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechartRACcontainer>


                  <timechart2container 
                    v-if="showchart4 && (chart4_type=='dual')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart4_metric1 + instanceLabel+':'+chart4_metric2 + instanceLabel"
                    :chart_id="chart4_group + '~' + chart4_metric1+':'+chart4_metric2"
                    stacked="false"
                    colorScheme="adhoc2"
                    reflines=false
                    :instance_num="this.chart4_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

                  <timechart2container 
                    v-if="showchart4 && (chart4_type=='dual_stacked')"
                    :collection_id="collection_id"
                    :collection_type="collection_type"
                    :user="user"
                    :label="chart4_metric1 + instanceLabel+':'+chart4_metric2 + instanceLabel"
                    :chart_id="chart4_group + '~' + chart4_metric1+':'+chart4_metric2"
                    stacked="true"
                    colorScheme="adhoc2stacked"
                    reflines=false
                    :instance_num="this.chart4_instances"
                    :start_date="this.start_date"
                    :end_date="this.end_date"
                    :start_date_min="this.start_date_min"
                    :end_date_max="this.end_date_max"
                    :showDateRange="true"
                  ></timechart2container>

      
            </b-card-body>
          </b-card>


      
    </div>
  </div>
</template>    


<script>
import { API } from "aws-amplify";
import TimeChartContainer from "./TimeChartContainer.vue";
import TimeChartRACContainer from "./TimeChartRACContainer.vue";
import TimeChart2Container from "./TimeChart2Container.vue";
import TimeChart4Container from "./TimeChart4Container.vue";
import TimeBarChartNContainer from "./TimeBarChartNContainer.vue";
import ScatterChartContainer from "./ScatterChartContainer.vue";
import axios from "axios";

export default {
  name: "app",
  components: {
    timechartcontainer: TimeChartContainer,
    timechartRACcontainer: TimeChartRACContainer,
    timechart2container: TimeChart2Container,
    timechart4container: TimeChart4Container,
    timebarchartncontainer: TimeBarChartNContainer,
    scatterchartcontainer: ScatterChartContainer
  },
  async created() {
    // console.log("test1");
    
    this.collection_id = this.param_collection_id;
    // is this shareMode?
    if ( (this.param_collection_id.substring(0,2)=="SD")  || (this.param_collection_id.substring(0,2)=="SB")) {
      console.log("shareMode");
      this.collection_id=this.param_collection_id.substring(2).split('-')[1];
      this.shareMode=true;
    }
    
    var tries = 2;
    var itsOK = false;
    while (tries > 0) {
      await API.get(
        "dbcsiAPI",
        `/dbcsi/authorized/${this.param_collection_id}`
      )
        .then(response => {
          // console.log("Got response:", response.data);
          if (response.data.authorized=="Y") {
            itsOK=true;
          }
          
          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Metrics-Authorized Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }
    
    if (!itsOK) {
      console.log("Sorry, not authorized to view this collection.  Routing back to main page.");      
      await this.$router.push('/');
    } 
    
   if (itsOK) {  
    // console.log("I am here1");
    tries = 2;
    while (tries > 0) {
      await API.get(
        "dbcsiAPI",
        `/dbcsi/${this.param_collection_id}/${this.collection_type}`
      )
        .then(response => {
          
          this.genItems = response.data;
          
          //pull out platform and DBsize
          
          for (var ii = 0; ii < this.genItems.length; ii++) {
            //is this PLATFORM_NAME
            if (this.genItems[ii].name == "PLATFORM_NAME") {
              // console.log("Platform", this.genItems[ii].value);
              this.gen_platform = this.genItems[ii].value;
              if ((this.gen_platform !="Linux_x86_64-bit")&& (this.gen_platform !="Microsoft_Windows_x86_64-bit")) {
                this.showAlertNonX86 = true;
              }

            }
            
            //is this IS_PDB
            if (this.genItems[ii].name == "IS_PDB") {
              // console.log("IS_PDB", this.genItems[ii].value);
              this.IS_PDB = this.genItems[ii].value;
            }

            //is this AWR_MINER_VERSION
            if (this.genItems[ii].name == "AWR_MINER_VERSION") {
              // console.log("Platform", this.genItems[ii].value);
              this.gen_dbcsi_script = this.genItems[ii].value;
            }
             
            //is this !CPU_CORE_COUNT or GLOBAL_CPU_CORE_COUNT
            if ((this.genItems[ii].name == "!CPU_CORE_COUNT")||(this.genItems[ii].name == "GLOBAL_CPU_CORE_COUNT")) {
              // console.log("cpu_core_count", this.genItems[ii].value);
              this.gen_cpu_core_count = this.genItems[ii].value;
            }
            
            //TOTAL_DB_SIZE_GB
            if (this.genItems[ii].name == "TOTAL_DB_SIZE_GB") {
              // console.log("Platform", this.genItems[ii].value);
              this.gen_db_size = this.genItems[ii].value;
            }
            //COUNT_TABLE
            if (this.genItems[ii].name == "COUNT_TABLE") {
              // console.log("Platform", this.genItems[ii].value);
              this.count_table = this.genItems[ii].value;
            }
            //COUNT_LINES_PLSQL
            if (this.genItems[ii].name == "COUNT_LINES_PLSQL") {
              // console.log("Platform", this.genItems[ii].value);
              this.count_lines_plsql = this.genItems[ii].value;
            }
            //HOSTS
            if (this.genItems[ii].name == "HOSTS") {
              // console.log("Platform", this.genItems[ii].value);
              this.hosts = this.genItems[ii].value;
            }
            //INSTANCES
            if (this.genItems[ii].name == "INSTANCES") {
              this.instances = this.genItems[ii].value;
            }  

            //INSTANCENUMS
            if (this.genItems[ii].name == "INSTANCENUMS") {
              this.instancenums = this.genItems[ii].value;
            }  
              
            //hide socket values
            if ((this.genItems[ii].name == "!CPU_SOCKET_COUNT")||(this.genItems[ii].name == "GLOBAL_CPU_SOCKET_COUNT") ||(this.genItems[ii].name == "NUM_CPU_SOCKETS")  ) {
              // console.log("Removing socket1", this.genItems.length);
              this.genItems.splice(ii,1);
              // console.log("Removing socket2", this.genItems.length);
              ii--;
            }
            
            //hide DEBUG values
            if ( this.genItems[ii].name.startsWith("DEBUG")  ) {
              // console.log("Removing DEBUG1", this.genItems.length);
              this.genItems.splice(ii,1);
              // console.log("Removing DEBUG2", this.genItems.length);
              ii--;
            }
            
            //hide DB_ values
             if ( this.genItems[ii].name.startsWith("DB_")  ) {
              this.genItems.splice(ii,1);
              ii--;
            }
           
            //SNAPSHOT_START
            if (this.genItems[ii].name == "SNAPSHOT_START") {
              // console.log("SNAPSHOT_START", this.genItems[ii].value);
              this.start_date = this.genItems[ii].value.split(' ')[0];
              this.start_date_min = this.start_date;
            }
            if (this.genItems[ii].name == "SNAPSHOT_STOP") {
              // console.log("SNAPSHOT_STOP", this.genItems[ii].value);
              this.end_date = this.genItems[ii].value.split(' ')[0];
              this.end_date_max = this.end_date;
            }
            
            
          }
          
          //setup instanceChoices
          this.instanceChoices = [
             { value: 'all', text: 'Display metrics for Entire Cluster' }
          ];

          //if we have instancenums use that
          if (this.instancenums!='') {
            for (var iii = 0; iii < this.instancenums.split(',').length ; iii++) {
                  this.instanceChoices.push({ value: this.instancenums.split(',')[iii], text: 'Instance '+this.instancenums.split(',')[iii]});
                }
          } else
          {
            //first adjust instances to be at least # of hosts
            let numHosts = this.hosts.split(',').length;
            if (this.instances*1 < numHosts) {
              console.log('adjusting instances to numHosts');
              this.instances = numHosts;
            }
            for (var iii = 1; iii <= this.instances*1 ; iii++) {
              this.instanceChoices.push({ value: iii, text: 'Instance '+iii});
            }
          }

          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Metrics-GeneralItems Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }
    
    await API.get("dbcsiAPI", `/dbcsi/adhoc_chart_columns/${this.collection_id}`)
      .then(response => {
        // console.log("Charts: I am here3");
        this.chart_columns = response.data;
        tries = 0;
      })
      .catch(error => {
        console.log("Chart adhoc_chart_columns Error:", error);
      });

    this.column_lov = [];
    for (var iii = 0; iii < this.chart_columns.length ; iii++) {
      // console.log(iii, this.chart_columns[iii].metric_name);
      // if (this.chart_columns[iii].metric_group=='MAIN_METRICS') {
        this.column_lov.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title + ' ('+this.chart_columns[iii].metric_units+')', metric_group:this.chart_columns[iii].metric_group});
      // }  
    }
    
    this.changeAdhocMetricGroup1('MAIN_METRICS');
    this.changeAdhocMetricGroup2('MAIN_METRICS');
    this.changeAdhocMetricGroup3('MAIN_METRICS');
    this.changeAdhocMetricGroup4('MAIN_METRICS');
    
  }
// console.log("I am here4");
  }, //end created()


  props: ["param_collection_id", "user"],
  data() {
    return {
      start_date: "",
      end_date: "",
      start_date_min: "",
      end_date_max: "",
      shareMode: false,
      showchart1: false,
      showReflineschart1: true, 
      chart1_instances: "all",
      chart1_metric1: "cpu_per_s",
      chart1_metric2: "cpu_per_s_max",
      chart1_type: "single",
      chart1_group: "MAIN_METRICS",
      showchart2: false,
      chart2_instances: "all",
      chart2_metric1: "cpu_per_s",
      chart2_metric2: "cpu_per_s_max",
      chart2_type: "single",
      chart2_group: "MAIN_METRICS",
      showReflineschart2: true, 
      showchart3: false,
      chart3_instances: "all",
      chart3_metric1: "cpu_per_s",
      chart3_metric2: "cpu_per_s_max",
      chart3_type: "single",
      chart3_group: "MAIN_METRICS",
      showReflineschart3: true, 
      showchart4: false,
      chart4_instances: "all",
      chart4_metric1: "cpu_per_s",
      chart4_metric2: "cpu_per_s_max",
      chart4_type: "single",
      chart4_group: "MAIN_METRICS",
      showReflineschart4: true, 
      chart_columns: [
          { metric_group: 'MAIN_METRICS', metric_name: 'aas', metric_title: 'Average Active Sessions', metric_units: ''}
        ],
      column_lov: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],
      column_lov1: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],
      column_lov2: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],
      column_lov3: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],
      column_lov4: [
          { value: 'aas', text: 'Average Active Sessions' }
      ],

      collection_type: "ora_v1",
      instances: "1",
      instancenums: "",
      instanceChoices: [
          { value: 'all', text: 'Display metrics for Entire Cluster' }
      ],
      genItems: [{ name: "Retrieving Data..." }],
      gen_platform: "",
      gen_dbcsi_script: "",
      gen_cpu_core_count: "",
      gen_db_size: "",
      IS_PDB: "",
      hosts: "",
      blended_cpu1: "",
      blended_iops1: "",
      blended_iomb1: "",
      count_table: "",
      count_lines_plsql: "",
      showCollapse: true,
      showMax: false,
      showReflines: true,      
      showHostCPU: false,
      showSizing: false,
      showCollapseIO: false,
      showCollapseSummary: false,      
      showCollapseBackup: false,
      showCollapseDiskSpace: false,
      showCollapseSessions: false,
      showCollapseMemory: true,
      showCollapseExa: false,
      showCollapseEC2: false,
      showCollapseMap: false,
      showCollapseMapOverview: false,
      showCollapseRDS: false,
      showCollapseAurora: false,
      showAlertNonX86: false,
      form: {
        cpu_algo: "cpu1",
        cpu_buffer_absolute: "0.5",
        cpu_buffer_percentage: "15%",
        cpu_thread_ratio: "1.00",
        diskspace_algo: "disk1_plus15",
        diskspace_buffer_absolute: "15",
        diskspace_buffer_percentage: "15%",
        iops_algo: "iops1",
        iops_buffer_absolute: "100",
        iops_buffer_percentage: "5%",
        iomb_algo: "iomb1",
        iomb_buffer_absolute: "50",
        iomb_buffer_percentage: "5%",
        memory_algo: "mem2_plus20_2",
        ebs_algo: "ebs1",
        savedtargets_algo: "targ1",
        platform_algo: "plat1"
      },
      suggestions: {
        VCPU: "",
        Memory: "",
        DiskSpace: "",
        IOPS: "", 
        Throughput: "",
        VolumeType: "",
        UseMAZ: "",
        TargetPlatform: "",
        Comments: ""        
      },
      sortBy: "LinuxOD",
      rdssortBy: "OracleOD",
      aurorasortBy: "AuroraPGOD",      
      ec2: {
        VCPU: "",
        Memory: "",
        Throughput: ""
      },
      ec2extras: {
        CPU_src: "",
        CPU_src_specint: "",
        VCPU_adj_other: "",
        ec2_shape: "",
        rds_shape: "",
        aurora_shape: "",
        aurora_flavor: ""
      },
      ebs: {
        DiskSpace: "",
        DiskSpace_src: "",
        DiskSpace_adj_other: "",
        IOPS: "",
        Backup: "0",
        VolumeType: "gp2",
        SnapshotDays: "",
        BackupType: "none",
        aurora_IOPS_write_adj: "",
        aurora_IOPS_peak_adj: "",
        aurora_IOPS_adj: ""
      },
      selected: [],
      rdsSelected: [],
      auroraSelected: [],
      currentPage: 1,
      perPage: 6,
      currentPageRDS: 1,
      currentPageAurora: 1,
      chart1iteration: 1


    };
  },
  methods: {


    changeAdhocMetricGroup1(value) {
      this.showchart1=false;
      this.column_lov1 = [];
      for (var iii = 0; iii < this.chart_columns.length ; iii++) {
        // console.log(iii, this.chart_columns[iii].metric_name);
        if (this.chart_columns[iii].metric_group==value) {
          this.column_lov1.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title + (this.chart_columns[iii].metric_units ? ' ('+this.chart_columns[iii].metric_units+')' : '') , metric_group:this.chart_columns[iii].metric_group} );
        }  
      }
    },
    changeAdhocMetricGroup2(value) {
      this.showchart2=false;
      this.column_lov2 = [];
      for (var iii = 0; iii < this.chart_columns.length ; iii++) {
        // console.log(iii, this.chart_columns[iii].metric_name);
        if (this.chart_columns[iii].metric_group==value) {
          this.column_lov2.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title + (this.chart_columns[iii].metric_units ? ' ('+this.chart_columns[iii].metric_units+')' : '') , metric_group:this.chart_columns[iii].metric_group} );
        }  
      }
    },
    changeAdhocMetricGroup3(value) {
      this.showchart3=false;
      this.column_lov3 = [];
      for (var iii = 0; iii < this.chart_columns.length ; iii++) {
        // console.log(iii, this.chart_columns[iii].metric_name);
        if (this.chart_columns[iii].metric_group==value) {
          this.column_lov3.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title + (this.chart_columns[iii].metric_units ? ' ('+this.chart_columns[iii].metric_units+')' : '') , metric_group:this.chart_columns[iii].metric_group} );
        }  
      }
    },
    changeAdhocMetricGroup4(value) {
      this.showchart4=false;
      this.column_lov4 = [];
      for (var iii = 0; iii < this.chart_columns.length ; iii++) {
        // console.log(iii, this.chart_columns[iii].metric_name);
        if (this.chart_columns[iii].metric_group==value) {
          this.column_lov4.push({ value: this.chart_columns[iii].metric_name, text: this.chart_columns[iii].metric_title + (this.chart_columns[iii].metric_units ? ' ('+this.chart_columns[iii].metric_units+')' : '') , metric_group:this.chart_columns[iii].metric_group} );
        }  
      }
    },

    changeAdhocMetricGroupAll(value) {
      this.showchart1=false;
      this.showchart2=false;
      this.showchart3=false;
      this.showchart4=false;
    },  

    async onSubmit(evt) {
      evt.preventDefault();
      // console.log("Add: I am here1");
      var tries = 0;
      var success = true;
      while (tries > 0) {
        await API.get("dbcsiAPI", `/dbcsi/collections`)
          .then(response => {
            // console.log("Add: Aurora is ready");
            //   this.collection_list = response.data;
            tries = 0;
            success = true;
          })
          .catch(error => {
            console.log(
              "Metrics.vue API Error (Aurora asleep? can retry):",
              error
            );
            console.log("Will retry.  Attempts Left:", (tries-1));
          });

        tries -= 1;
      }
      
      // get latest description
      
      let new_description = "";
      let new_database = "";
      for (var ii = 0; ii < this.genItems.length; ii++) {
            //is this PLATFORM_NAME
            if (this.genItems[ii].name == "DESCRIPTION") {
              // console.log("Description:", this.genItems[ii].value);
              new_description = this.genItems[ii].value;
            }
            if (this.genItems[ii].name == "DATABASE") {
              // console.log("Description:", this.genItems[ii].value);
              new_database = this.genItems[ii].value;
            }
      }      
      
      if (success) {
        // console.log("Add: I am here4");
        //do a put to /collections/collection_id/reviewComments
        const putParams = {
          body: {
            review_comments: {
              comments: this.comments,
              ec2: this.ec2,
              ebs: this.ebs,
              ec2extras: this.ec2extras
            },
            description: new_description,
            database: new_database,
            targetconfig_ec2: this.targetconfig_ec2,
            targetconfig_rds: this.targetconfig_rds,
            targetconfig_aurora: this.targetconfig_aurora           
          }
        };

        await API.put(
          "dbcsiAPI",
          `/dbcsi/${this.collection_id}/${
            this.collection_type
          }/reviewComments`,
          putParams
        )
          .then(response => {
            success = true;
            // console.log("Metrics- ReviewComments: new collection_id=", new_id);
          })
          .catch(error => {
            console.log("Metrics- ReviewComments.put Error:", error);
          });
      }
    },
    onReset(evt) {
      evt.preventDefault();

    }
  },
  computed: {
    instanceLabel() {
      if (this.chart1_instances=='all') {
        return '';
      } else {
        return '- Instance#'+this.chart1_instances;
      }
    }

  }
};
</script>

<style>
</style>
